import { ensureLeadingSlash } from '../../components/shared/url-utils';
import { pagesSlug } from '../../routes/routing';

const pathToStrip = `(/[a-z]{2})?/${pagesSlug}(/.*)?`;

export const stripPagesSlug = (url: URL): { strippedUrl: URL } | undefined => {
  const stripped = stripPagesSlugPathname(url.pathname);
  if (!stripped) {
    return undefined;
  }
  const newUrl = new URL(url);
  newUrl.pathname = stripped.strippedUrl;
  return { strippedUrl: newUrl };
};

export const stripPagesSlugPathname = (
  originalUrl: string,
): { strippedUrl: string } | undefined => {
  const match = ensureLeadingSlash(originalUrl).match(pathToStrip);

  if (match === null) {
    return undefined;
  }

  const [_, lang, path] = match;

  return { strippedUrl: (lang ?? '') + (path ?? '') };
};

export const stripLocalePrefixPathname = (
  originalUrl: string,
  locale: string,
): { strippedUrl: string } | undefined => {
  const url = ensureLeadingSlash(originalUrl);
  if (url === `/${locale}`) {
    return { strippedUrl: '/' };
  }
  return url.startsWith(`/${locale}/`) ? { strippedUrl: url.slice(locale.length + 1) } : undefined;
};
